export default "__VITE_PUBLIC_ASSET__355d39e3__"